module.exports = __webpack_public_path__ + "media/images/img05-433c4eeb286719ee465115af4f9e449c.png";